<nb-card accent="danger">
  <nb-card-header class="header-card">
    <h2>Aviso Alteração de Produtos</h2>
  </nb-card-header>
  <nb-card-body>
    <div class="container">
      <div class="table-scroll">
        <p-table [value]="changedPrices" [scrollable]="true" scrollHeight="400px" width="90%">
          <ng-template pTemplate=header>
            <tr>
              <th>Produto</th>
              <th>Unid. Medida</th>
              <ng-container *ngIf="this.priceProblem">
                <th>Preço Total Antigo</th>
                <th>Novo Preço Total</th>
                <th>Diferença de Preço</th>
              </ng-container>
              <ng-container *ngIf="this.stockProblem">
                <th>Estoque</th>
                <th colspan="2">Quantidade</th>
              </ng-container>
              <th colspan="2">
                <div class="btn-group center-button" role="group" aria-label="Basic example">
                  <button type="button" class="btn" (click)="keepAll()"
                    [ngClass]="{'btn-primary': allItems, 'btn-outline-primary': !allItems}">
                    Manter Todos
                  </button>
                  <button type="button" class="btn" (click)="removeAll()"
                    [ngClass]="{'btn-danger': allItems !== undefined && !allItems, 'btn-outline-danger': allItems === undefined || allItems}">
                    Remover Todos
                  </button>
                </div>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-changed let-index="rowIndex">
            <tr *ngIf="!changed.active || changed.observation">
              <ng-container *ngIf="changed.observation">
                <td>{{ changed.orderItem.productName }}</td>
                <td colspan="5"><b class="text-danger">{{changed.observation}}</b></td>
              </ng-container>
              <ng-container *ngIf="!changed.observation">
                <td>{{ changed.orderItem.productName }}</td>
                <td colspan="5"><b class="text-danger">O produto não está mais disponível na loja e será removido do
                    carrinho!</b></td>
              </ng-container>
            </tr>
            <tr *ngIf="changed.active && !changed.observation">
              <td id="{{changed.orderItem.productId}}{{ changed.orderItem.classificationId}}"
                style="padding-bottom: 0px; border: none;">
                {{ changed.orderItem.productName }}
              </td>
            </tr>
            <tr *ngIf="changed.active && !changed.observation">
              <td></td>
              <td>{{ changed.orderItem.measurementUnitInitials }}</td>
              <ng-container *ngIf="this.priceProblem">
                <td>
                  <div *ngIf="changed.newPrice != null">{{ changed.orderItem.price | currency: 'BRL' }}</div>
                </td>
                <td>{{ changed.newPrice | currency: 'BRL' }}</td>
                <td>
                  <div *ngIf="changed.newPrice != null" class="font-weight-bold"
                    [ngClass]="{'text-danger': (changed.newPrice - changed.orderItem.price) > 0, 'text-success': (changed.newPrice - changed.orderItem.price) < 0}">
                    {{ (changed.newPrice - changed.orderItem.price) | currency: 'BRL' }}</div>
                </td>
              </ng-container>
              <ng-container *ngIf="this.stockProblem">
                <td>{{changed.stockQuantity}}</td>
                <td style="padding: 0px;" colspan="2">
                  <div class="stock-section" *ngIf="changed.stockQuantity != null">
                    <div class="input-group-prepend">
                      <button pButton pRipple class="p-button-rounded p-button-secondary p-button-text" type="button"
                        (click)="minus(index)">
                        <i class="pi pi-minus"></i>
                      </button>
                    </div>
                    <input [ngClass]="{'text-danger': changed.orderItem.quantity > changed.stockQuantity}"
                      [(ngModel)]="changed.orderItem.quantity" type="text" inputmode="numeric" class="input-number"
                      (change)="formatNumber(index)" onlyNumbers>
                    <div class="input-group-append">
                      <button pButton pRipple class="p-button-rounded p-button-secondary p-button-text" type="button"
                        (click)="plus(index)">
                        <i class="pi pi-plus"></i></button>
                    </div>
                  </div>
                </td>
              </ng-container>

              <td colspan="2">
                <div class="btn-group center-button" role="group" aria-label="Basic example">
                  <button type="button" class="btn" (click)="keepItem(changed)" [disabled]="blockStock() && getStock(changed) == 0"
                    [ngClass]="{'btn-primary': changed.keep, 'btn-outline-primary': !changed.keep}">{{(blockStock() && getStock(changed) == 0) ? 'Produto sem estoque' : 'Manter'}}</button>
                  <button type="button" class="btn" (click)="removeItem(changed)"
                    [ngClass]="{'btn-danger': changed.keep !== undefined && !changed.keep, 'btn-outline-danger': changed.keep === undefined || changed.keep}">Remover</button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer class="d-flex flex-row-reverse">
    <button type="button" class="btn btn-success" (click)="confirmSelection()" [disabled]="!canClose">
      Confirmar Alterações
    </button>
  </nb-card-footer>
</nb-card>